export default {"src":"/_next/static/media/ChevronDownLight.d1b3e8af.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};